import ReactPlayer from "react-player";

const VideoPlayer = () => {
  const url = "https://youtu.be/BX548LuZA4Y";
  return <ReactPlayer width="100%" height="100%" controls={true} url={url} />;
};

export default VideoPlayer;
